import { AxiosResponse } from "axios";
import apiClient from "../api/axios";
import { handleApiError } from "../api/handleApiError";
import { Assets, AssetsType, AssetType, AssetTypeResponse } from "../models/Asset";

interface AssetsResponse {
  results: { assets: Assets[] };
}

const AssetsService = {
  getAll: async (): Promise<Assets[]> => {
    try {
      const response: AxiosResponse<AssetsResponse> = await apiClient.get("/v1/assets");
      return response.data.results.assets.filter((e) => e.assetStatus !== "deactivated");
    } catch (error) {
      handleApiError(error, {}, "error-get-assets");
    }
    return [];
  },

  getAssetTypes: async (emissionGroup: AssetsType): Promise<AssetType[]> => {
    try {
      const response: AxiosResponse<AssetTypeResponse> = await apiClient.get(
        `/v1/asset-types/${emissionGroup}`
      );
      return response.data.results.assetTypes;
    } catch (error) {
      handleApiError(error);
    }
    return [];
  },
};

export default AssetsService;
